module.exports = __webpack_public_path__ + "img/placeholder.ad56e356.jpg";